import React from 'react'

import cn from '../../libs/class-names'

import fileAttachmentIcon from '../../assets/icons/file-attachment.svg'

import Icon from '../icon'
import {Props as IconProps} from '../icon/icon'

interface Props {
  classNames?: string[]
  headline: React.ReactNode
  button?: React.ReactNode
  icon?: IconProps['source']
}

const MessageAttachment = ({classNames, headline, button, icon}: Props) => (
  <div className={cn('MessageAttachment', {}, classNames)}>
    <div className="MessageAttachment__image">
      <Icon source={icon || fileAttachmentIcon} />
    </div>
    <div className="MessageAttachment__headline">{headline}</div>
    {button}
  </div>
)

export default MessageAttachment
